<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useFloatingContactStore } from '../../../../../store/contacts/floatingContact.ts';

import Select from '../../../../Select/Select.vue';
import type ContactCard from '../../../../ContactCard/ContactCard.vue';
import ContactResults from '../../ContactResults/ContactResults.vue';

type ContactCardProps = InstanceType<typeof ContactCard>['$props'];

type Props = {
  placeholder?: string;
  options?: {
    name: string;
    icon?: string;
    contacts: ContactCardProps[];
  }[];
  optionsTitle?: string;
};

const props = defineProps<Props>();

const emit = defineEmits(['submit']);

const stateStore = useFloatingContactStore();
const { view, isFinder } = storeToRefs(stateStore);

const selectedCountryRef = ref<string | undefined>(undefined);
const selectedOptionRef = ref<Props['options'] | undefined>(undefined);
const contactsRef = ref<ContactCardProps[] | undefined>(undefined);

const handleSelectChange = (e) => {
  selectedOptionRef.value = e;
  contactsRef.value = e.contacts;
  selectedCountryRef.value = props.options?.find(
    (option) => JSON.stringify(option.contacts) === JSON.stringify(e.contacts),
  )?.name;

  emit('submit');
};

onBeforeUnmount(() => {
  selectedOptionRef.value = undefined;
  contactsRef.value = undefined;
});
</script>
<template>
  <div :class="$style.container">
    <Select
      v-show="!view.includes('fab_l2_')"
      aria-label="content finder select"
      :class="$style.selectInput"
      colour="oneXP"
      label="name"
      :searchable="true"
      :select-options="options"
      :select-value="selectedOptionRef"
      track-by="name"
      @on-change="(e) => handleSelectChange(e)"
    />
    <div
      v-if="contactsRef"
      v-show="view.includes('fab_l2_') && isFinder && contactsRef"
      :class="$style.floatingContactFlyOut"
    >
      <div :class="$style.contactFinderSelectWrapper">
        <Select
          aria-label="content finder select in second screen"
          :class="$style.selectInput"
          colour="oneXP"
          label="name"
          :searchable="true"
          :select-options="options"
          :select-value="selectedOptionRef"
          track-by="name"
          @on-change="(e) => handleSelectChange(e)"
        />
      </div>
      <ContactResults
        :key="JSON.stringify(contactsRef) + 1"
        :contacts="contactsRef"
        :selected-country="selectedCountryRef"
        :title="optionsTitle"
      />
    </div>
  </div>
</template>
<style lang="sass" module src="./ContactFinderSelect.scss" />
